function EllipsisVIcon({ className }) {
  return (
    <svg className={`ic ${className}`} xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">
      <path
        fill="currentColor"
        d="M12 7a2 2 0 1 0-2-2a2 2 0 0 0 2 2m0 10a2 2 0 1 0 2 2a2 2 0 0 0-2-2m0-7a2 2 0 1 0 2 2a2 2 0 0 0-2-2"
      />
    </svg>
  );
}

export default EllipsisVIcon;
